import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import GoodsJobList from './GoodsJobList';
import GoodsJobDetail from './GoodsJobDetail';

@inject(({ commonStore, goodsJobStore, userInfoStore }) => ({
  commonStore: commonStore,

  setCommonStoreInfo: goodsJobStore.setCommonStoreInfo,
  onClear: goodsJobStore.onClear,
  viewMode: goodsJobStore.viewMode,
  onViewMode: goodsJobStore.onViewMode,
  disGoodsJobList: goodsJobStore.disGoodsJobList,

  disJobList: userInfoStore.disJobList,
  jobList: userInfoStore.jobList
}))
@observer
class GoodsJobContainer extends Component {

  UNSAFE_componentWillMount() {
    this.props.setCommonStoreInfo(this.props.commonStore);
    this.props.onClear();
    this.props.disGoodsJobList(1);

    // 직무리스트 가져오기
    this.props.disJobList('', '', 'Y');
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.viewMode !== this.props.viewMode) {
      if (nextProps.viewMode === 'list') {
        this.props.history.push('/goodsJobManage');
      } else {
        this.props.history.push('/goodsJobManage/'+nextProps.viewMode);
      }
    }
    if(nextProps.location.pathname !== this.props.location.pathname) {
      // 뒤로가기 버튼을 눌러서 주소가 바뀌었을 때 viewMode 상태가 detail 이면 list로 변경해준다.
      if (nextProps.location.pathname.lastIndexOf("/") === 0) {
        if (nextProps.viewMode !== 'list') {
          this.props.onViewMode("list");
        }
      } else {
        let pageMode = nextProps.location.pathname.substring(nextProps.location.pathname.lastIndexOf("/")+1);
        // console.log("pageMode", pageMode);
        if (nextProps.viewMode !== pageMode) {
          this.props.onViewMode(pageMode);
        }
      }
    }
  }

  render() {
    const { sessionLoginInfo } = this.props.commonStore;
    const { viewMode, jobList } = this.props;
    return (
      viewMode === 'list'
      ? <GoodsJobList
          ceType={(sessionLoginInfo !== null && sessionLoginInfo.ceType !== undefined &&  sessionLoginInfo.ceType !== null) 
            ? sessionLoginInfo.ceType : "" }
          jobList={jobList}
        /> 
      : <GoodsJobDetail
          ceType={(sessionLoginInfo !== null && sessionLoginInfo.ceType !== undefined &&  sessionLoginInfo.ceType !== null) 
            ? sessionLoginInfo.ceType : "" }
          jobList={jobList}
        />
    );
  }

}

export default withRouter(GoodsJobContainer);
